import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const getMipsAPI = async (risId) => {
    return await axios.get(`/api/v1/admin/mips`,{
        params: {
            risId
        }})
        .then(function (response) {
            if (response.data) {
                return { success: true, mip: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addUpdateMipAPI = async (mip) => {
    return await axios.post(`/api/v1/add-update-mip`, mip)
        .then(function (response) {
            if (response.data) {
                return { success: true, mip: response.data };
            } else {
                return { success: false, error: response.message };
            }
        })
        .catch(function (error) {
            if(error && error.response && error.response.data){
                return { success: false, error: error.response.data.message };
            }
            return { success: false, error };
        });
}

export const getUserMipsAPI = async () => {
    return await axios.get(`/api/v1/fetch-user-mips`)
        .then(function (response) {
            if (response.data) {
                return { success: true, userMips: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}